import React, { useEffect, useState } from 'react';
import { LAMPORTS_PER_SOL } from '@solana/web3.js';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useConnection, useWallet } from '@solana/wallet-adapter-react';
import WalletAdapterButton from '../common/WalletConnection/WalletAdapterButton';
import MainContainer from '../common/MainContainer/MainContainer';
import { isProdMainnet } from '../common/util';
import { getPortalConfig, PortalConfig } from '../common/config';
import Log from '../common/logging';

export default function WalletConnectionScreen(): JSX.Element {
  const [config] = useState<PortalConfig>(getPortalConfig());
  const { connection } = useConnection();
  const { t } = useTranslation();
  const history = useHistory();

  const { wallet, connected, publicKey } = useWallet();

  /**
   * on connection, check if the wallet has got enough lamports, if not
   * then request an airdrop
   */
  useEffect(() => {
    const airdropToWalletIfNeeded = async () => {
      if (publicKey && connected && !isProdMainnet) {
        const balance = await connection.getBalance(publicKey);
        if (balance / LAMPORTS_PER_SOL < 0.1) {
          await connection.requestAirdrop(publicKey, LAMPORTS_PER_SOL * 0.1);
          toast.success(`Successfully airdropped 0.1 SOL to ${publicKey.toBase58()}`, { duration: 4000 });
        }
      }
    };
    airdropToWalletIfNeeded().catch(Log.error);
  }, [config.network, connected, publicKey]);

  useEffect(() => {
    if (wallet && connected) {
      history.push('/status');
    }
  }, [wallet, connected, history]);

  return (
    <MainContainer>
      <div className="wallet-connection-panel full:px-10 wider:px-10 wide:px-8 medium:px-6 narrow:px-6 justify-center items-center flex flex-col relative">
        <div className="wallet-connection-image">
          <img src="PassImage.png" alt="Civic Pass Logo" />
        </div>

        <h2 className="wallet-connection-description text-center px-8">
          {t('screens.walletConnection.description', { context: config.i18nContext })}
        </h2>

        <h1 className="mt-5 mb-5">{t('screens.walletConnection.title')}</h1>

        <div className="wallet-connection-button mt-5">
          <WalletAdapterButton className="connect-wallet" buttonLabel={t('screens.walletConnection.button')} />
        </div>
      </div>
    </MainContainer>
  );
}
